import createIconComponent from './utils/createIconComponent';
import React from 'react';

const ChevronDownSolid = createIconComponent({
  width: 271,
  height: 480,
  content: (
    <g>
      <path d='M365.04345703125,150.093505859375 q0,5.619154930114746 -4.600069522857666,9.941582679748535 l-214.36325073242188,201.4250946044922 q-4.600069522857666,4.322426795959473 -10.580161094665527,4.322426795959473 t-10.580161094665527,-4.322426795959473 l-214.36325073242188,-201.4250946044922 q-4.600069522857666,-4.322426795959473 -4.600069522857666,-9.941582679748535 t4.600069522857666,-9.941582679748535 l23.000349044799805,-21.612133026123047 q4.600069522857666,-4.322426795959473 10.580161094665527,-4.322426795959473 t10.580161094665527,4.322426795959473 l180.78274536132812,169.87136840820312 l180.78274536132812,-169.87136840820312 q4.600069522857666,-4.322426795959473 10.580161094665527,-4.322426795959473 t10.580161094665527,4.322426795959473 l23.000349044799805,21.612133026123047 q4.600069522857666,4.322426795959473 4.600069522857666,9.941582679748535 z' />
    </g>
  ),
});

ChevronDownSolid.displayName = 'ChevronDownSolid';
export default ChevronDownSolid;
